module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_maedori-56d13688bee9b88527553782153aa543.jpg";